import { Component, Inject } from "@angular/core";
import { LicenseService } from "../../../services/LicenseService";
import { AppLoaderService } from "../../../../services/app-loader/app-loader.service";
import { MD_DIALOG_DATA, MdDialogRef } from "@angular/material";
import { Router } from "@angular/router";
import { AdalService } from "../../../shared/adal.service";

@Component({
    styles:[require('./view-lz30-purchase-history.component.css')],
    template:require('./view-lz30-purchase-history.component.html'),
    selector:'view-lz30-purchase-history'
})
export class ViewLZ30PurchaseLicenseHistory{
    dialogTitle='View LZ30 Purchase License History';
    errorMessage="";
    SelectedCustomerDetail;
    LZ30PurchaseLicenseHistory;
    Lz30PurchaselicenceDisplayList;
    isLoading=false;
    constructor(
        private licenseService:LicenseService,
        private appLoader:AppLoaderService,
        public dialogRef:MdDialogRef<ViewLZ30PurchaseLicenseHistory>,
        private adalService:AdalService,
        private router:Router,
        @Inject(MD_DIALOG_DATA) public dialogData
    ){
        if (!this.adalService.getCachedToken()) {
            this.dialogRef.close(null);
            this.router.navigate(["login"]);
        }
        else{
            this.SelectedCustomerDetail=dialogData.SelectedCustomerDetail,
            this.Lz30PurchaselicenceDisplayList=dialogData.purchaseLicenseDisplayData
            this.getLZ30PurchaseLicenseHistory()
        }
    }
    getLZ30PurchaseLicenseHistory(){
        this.isLoading=true;
        this.licenseService.getLz30PurchaseHistory(this.SelectedCustomerDetail.LZ30UserDeviceId).subscribe((data)=>{
            if(!data.IsError && data.DataObject!=null){
                this.LZ30PurchaseLicenseHistory=data.DataObject;
            }
            else{
                this.errorMessage=data.Error;
            }
            this.isLoading=false;
        })
    }
    onCancel(){
        this.dialogRef.close(this.Lz30PurchaselicenceDisplayList)
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/license-portal/lz30/view-lz30-purchase-history/view-lz30-purchase-history.component.ts